import { CapoPlugin } from "/mnt/agent/work/a3eaf6f60f6858aa/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];